import React from "react";

import { useSmartrrTheme } from "@customer-app/account/views/OperationAquarius/hooks/useSmartrrTheme";

export const CircleCheck = () => {
  const theme = useSmartrrTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" style={{ fill: theme.modernCardBackground }} />
      <path d="M8 12.5l3 3 5-6" />
    </svg>
  );
};
